import {
  AGGREGATIONS_BY_LISTING_SECTION_ID as sharedAggregationsByListingSectionId,
  FILTER_NAMES_TO_AGGREGATIONS_DICTIONARY as sharedFilterNamesToAggregationsDictionary
} from '../common/filtersAggregations.js'

// Define only the filters aggregations that are different from the common ones
export const AGGREGATIONS_BY_LISTING_SECTION_ID = {...sharedAggregationsByListingSectionId}
export const FILTER_NAMES_TO_AGGREGATIONS_DICTIONARY = {...sharedFilterNamesToAggregationsDictionary}
